import React from 'react';
import './Navbar.css';
import create from '../../assets/create-icon.svg';
import hamburger from '../../assets/hamburger-icon.svg';
import mic from '../../assets/mic-icon.svg';
import notification from '../../assets/notification-icon.svg';
import profile from '../../assets/profile-icon.jpg';
import search from '../../assets/search-icon.svg';
import youtube from '../../assets/youtube-icon.svg';
import { Link } from 'react-router-dom';
import ProfileMenu from '../ProfileMenu/ProfileMenu';
import Tooltip from './Tooltip';

const Navbar = ({
  handleToggler,
  width,
  isMenuOpen,
  handleMenuToggler,
  setIsMenuOpen,
}) => {
  const username = '@aaron123';

  return (
    <nav>
      <div className='left-nav'>
        <div className='menu' onClick={handleToggler}>
          <img src={hamburger} alt='hamburger icon' className='icon' />
        </div>
        <Link to={'/youtube_clone'} className='logo'>
          <img src={youtube} alt='youtube icon' className='yt-icon' />
          <span className='country'>NG</span>
        </Link>
      </div>
      <div className='center-nav'>
        <div className='search'>
          <input type='text' placeholder='Search' />
          <button className=' tooltip search-btn'>
            <img src={search} />
            <div className='tooltiptext'>Search</div>
          </button>
        </div>
        <div className='tooltip mic'>
          <img src={mic} />
          <div className='tooltiptext'>Search with your voice</div>
        </div>
      </div>
      <div className='right-nav'>
        {width <= 600 ? (
          <>
            <Tooltip classname={'search-mobile'} icon={search} text='Search' />
            <Tooltip
              classname={'mic-mobile'}
              icon={mic}
              text='Search with your voice'
            />
          </>
        ) : null}

        <Tooltip classname={'create'} icon={create} text='Create' />
        <Tooltip
          classname={'notification'}
          icon={notification}
          text='Notifications'
          notify
        />

        <div onClick={handleMenuToggler} className='profile'>
          <img src={profile} />
        </div>
        {isMenuOpen ? <ProfileMenu username={username} /> : null}
      </div>
    </nav>
  );
};

export default Navbar;
